import ErrorPage from '@/components/ErrorBoundary/ErrorPage'

import { RouteObject } from 'react-router-dom'
import DepartmentDashboard from './components/DepartmentDashboard'
import { TourProvider } from '@/components/TourProvider'
import mainboardSteps from './components/Mainboard/Tour'

const DashboardModule: RouteObject = {
    path: '',
    children: [
        {
            path: '',
            element: (
                <TourProvider steps={mainboardSteps}>
                    <DepartmentDashboard />
                </TourProvider>
            ),
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default DashboardModule
